import React from 'react';

const MobileNavigationHeader = () => (
  <header className="integrationsPortal-nav-header media--available@tablet">
    <h3 className="integrationsPortal-nav-header-title">My Integrations</h3>
  </header>
);

export default MobileNavigationHeader;
